import {useTranslation} from '@aboutyou/i18n';
import {withLegacyProviders} from '../../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/AccountArea/BankDataPage';
import {
  AuthenticatedView,
  MissionBadge,
  RedirectBack,
  useBICTranslations,
} from '@aboutyou/logic-components';
import {FullPageSpinner} from '@aboutyou/ui-components';
import React from 'react';

export const CustomerBankData = () => {
  const {t} = useTranslation();
  const bicTranslations = useBICTranslations();

  return (
    <AuthenticatedView
      context="customer-bank-data-page"
      View={CustomerBankDataLegacy}
      Fallback={() => <RedirectBack fallbackUrl="/" />}
      Loading={FullPageSpinner}
      viewProps={{
        favouritePageLabel: t('Favourites'),
        bicTranslations,
        MissionBadge,
      }}
    />
  );
};

const CustomerBankDataLegacy = withLegacyProviders(Page);
